'use client';

import Link from 'next/link';
import BlogCard from './BlogCard';
import { useT } from '@/contexts/LanguageContext';

/**
 * "From the Blog" strip for the marketing home. Receives already-fetched
 * posts as a prop (fetched server-side in the home Server Component), so the
 * content is present in the initial HTML for SEO even though the marketing
 * home shell is a client component. Renders nothing when there are no posts.
 */
export default function FeaturedBlogs({ posts = [] }) {
  // Hooks run before the early return — bailing out first would change the
  // hook count between a page with featured posts and one without.
  const t = useT();

  if (!Array.isArray(posts) || posts.length === 0) return null;
  return (
    <section
      className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8"
      data-testid="home-featured-blogs"
    >
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          {/* Only the section furniture follows the site language — post
              titles and excerpts are whatever the author wrote. */}
          <h2 className="text-3xl font-bold tracking-tight text-gray-900">{t('blogStrip.heading')}</h2>
          <p className="mt-2 text-gray-600">
            {t('blogStrip.body')}
          </p>
        </div>
        <Link
          href="/blog"
          className="inline-flex items-center gap-1 rounded-full border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-800 transition-colors hover:border-blue-600 hover:text-blue-700"
          data-testid="home-featured-blogs-viewall"
        >
          {t('blogStrip.viewAll')}
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {posts.slice(0, 3).map((post) => (
          <BlogCard key={post.slug} post={post} />
        ))}
      </div>
    </section>
  );
}
